import React from "react"
import { useIntl } from "gatsby-plugin-react-intl"

const QuoteLink = ({ hotelId, locale }) => {
  const intl = useIntl()

  return locale === "en" ? (
    <a className="link" href="/en/mauritius-hotels/ask-quote">Request a quote</a>
  ) : (
    <a className="link" href="/demandez-un-devis">Demander un Devis</a>
  )
}

export default QuoteLink
